import React from 'react';
import PropTypes from 'prop-types';

import classes from './ListItemTR.css';

const listItemTR = props => {
  const { title, value } = props;
  return (
    <li className={classes.ListItemTR}>
      <p>{title}</p>
      <p>{value}</p>
    </li>
  );
};

listItemTR.propTypes = {
  title: PropTypes.string
};

export default listItemTR;
